module.exports = __webpack_public_path__ + "static/media/picto-paanteon.f439683c.svg";